import {defineMessages} from "@project/i18n";

export const appShellMessages = defineMessages({
  accountActions: {
    id: "layout.account.actions",
    defaultMessage: "Account actions",
    description: "Accessible label for account actions list",
  },
  chooseExtensionShortcut: {
    id: "layout.extensions.chooseShortcut",
    defaultMessage: "Choose which extension opens from header shortcut.",
    description: "Description in extension switcher sheet",
  },
  extensions: {
    id: "layout.extensions",
    defaultMessage: "Extensions",
    description: "Generic extensions label",
  },
  goToDashboard: {
    id: "layout.goToDashboard",
    defaultMessage: "Go to dashboard",
    description: "Accessible label for sidebar brand button",
  },
  hiddenBreadcrumbs: {
    id: "layout.breadcrumbs.hidden",
    defaultMessage: "Hidden breadcrumbs",
    description: "Title for collapsed hidden breadcrumbs ellipsis",
  },
  manageSignInAndSecurity: {
    id: "layout.account.manageSignInAndSecurity",
    defaultMessage: "Manage sign-in and security",
    description: "Opens Keycloak Account Console in the top-level browsing context",
  },
  logOut: {
    id: "layout.account.logout",
    defaultMessage: "Log Out",
    description: "Log out menu item label",
  },
  logOutDescription: {
    id: "layout.account.logout.description",
    defaultMessage:
      "Are you sure you want to log out? You'll need to sign in again to access your account.",
    description: "Description in log out confirmation dialog",
  },
  logOutTitle: {
    id: "layout.account.logout.title",
    defaultMessage: "Log out?",
    description: "Title in log out confirmation dialog",
  },
  notifications: {
    id: "layout.notifications",
    defaultMessage: "Notifications",
    description: "Accessible label for notifications action",
  },
  search: {
    id: "layout.search",
    defaultMessage: "Search",
    description: "Accessible label for search action",
  },
  settings: {
    id: "layout.settings",
    defaultMessage: "Settings",
    description: "Settings menu item label",
  },
  showHiddenBreadcrumbs: {
    id: "layout.breadcrumbs.showHidden",
    defaultMessage: "Show hidden breadcrumbs",
    description: "Accessible label for hidden breadcrumbs dropdown trigger",
  },
  tapExtensionsHoldToSwitch: {
    id: "layout.extensions.mobileHint",
    defaultMessage: "Tap extensions. Hold to switch.",
    description: "Tooltip on mobile extensions button",
  },
  toggleExtensions: {
    id: "layout.extensions.toggle",
    defaultMessage: "Toggle extensions",
    description: "Accessible label for mobile extensions button",
  },
  userMenu: {
    id: "layout.account.userMenu",
    defaultMessage: "User menu",
    description: "Accessible label for desktop user menu trigger",
  },
});
